import { Component, Input } from '@angular/core';
import { Summary, CurrencyAndTaxes } from '@models/models';

@Component({
	selector: 'quote-amount-info',
	template: require('./quote-amount-info.component.html'),
	styles: [require('./quote-amount-info.component.scss')]
})
export class QuoteAmountInfoComponent {
	@Input() summary: Summary;
	@Input() currencyAndTax: CurrencyAndTaxes;
	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/quote/common/quote-amount-info/quote-amount-info.component.ts